export default __webpack_public_path__ + "139c91b6b602db66571999313d58b60b.png";